"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_strings_1 = require("owa-strings");
function contructAppNexusPageGroup(isOneClick) {
    var clickTypeLetter = isOneClick ? '1' : '2';
    return owa_strings_1.format('WAN{0}{1}', clickTypeLetter, 'USEN');
}
exports.contructAppNexusPageGroup = contructAppNexusPageGroup;
function GenerateAppNexusAd(rawAdObject, appNexusMessageAdType, adMarket, triggerEvent, isOneClick) {
    var rawAppNexusObject = rawAdObject;
    if (rawAppNexusObject && rawAppNexusObject.native) {
        var appNexusPreviewTexts = rawAppNexusObject.native.body
            ? rawAppNexusObject.native.body
            : rawAppNexusObject.native.title;
        if (rawAppNexusObject.native.cta) {
            appNexusPreviewTexts = appNexusPreviewTexts + ' ' + rawAppNexusObject.native.cta;
        }
        return {
            adSender: rawAppNexusObject.native.sponsoredBy,
            adSubject: rawAppNexusObject.native.title,
            adPreviewTexts: appNexusPreviewTexts,
            adCallToActionTextsBelowImage: rawAppNexusObject.native.cta,
            adImageUrl: rawAppNexusObject.native.image ? rawAppNexusObject.native.image.url : null,
            adFavIconurl: rawAppNexusObject.native.icon ? rawAppNexusObject.native.icon.url : null,
            adImageTargetUrl: rawAppNexusObject.native.clickUrl,
            adTextsAboveImage: rawAppNexusObject.native.body
                ? rawAppNexusObject.native.body
                : rawAppNexusObject.native.title,
            adType: appNexusMessageAdType,
            adChoiceUrl: 'https://choice.microsoft.com',
            adMarket: adMarket,
            adRefreshEvent: triggerEvent,
            adOneClickDirectTargetUrl: isOneClick ? rawAppNexusObject.native.clickUrl : null,
            isRead: false,
        };
    }
    else {
        return null;
    }
}
exports.GenerateAppNexusAd = GenerateAppNexusAd;
//# sourceMappingURL=appnexusUtils.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/owa-mail-messagead-orchestration/lib/utils/appnexusUtils.js
// module id = 3914
// module chunks = 67